/**
 * @fileoverview SourcesPage icons. JSON files in `public/icons/SourcesPage/`.
 */
export const SOURCES_ICONS = {
  sourceLink: '/icons/SourcesPage/wired-outline-11-link-unlink-hover-bounce.json',
} as const;
